import React from "react";
import { appleImg, bagImg, searchImg } from "../utils";
import { navLists } from "../constants";
const Navbar = () => {
  return (
    <header className="w-full py-5 sm:px-10 flex justify-between items-center">
      <nav className="z-10 justify-between flex screen-max-width w-full">
        <img className="pl-6" src={appleImg} />

        <div className="flex flex-1 justify-center max-sm:hidden">
          {navLists.map((nav) => (
            <div
              key={nav}
              className="px-4 text-sm cursor-pointer transition-all text-gray-400 hover:text-white"
            >
              {nav}
            </div>
          ))}
        </div>
        <div className="flex sm:gap-5 pr-6  gap-3.5">
          <img className="screen-max-width w-full" src={searchImg} />
          <img className="screen-max-width w-full" src={bagImg} />
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
